import { useState } from 'react'
import { useCountdown } from '../../../components/Questionnaire/stopwatch/Stopwatch'
import { useBottomSheet } from '../../../state-management/contexts/BottomSheetContext'
import { LockDownTimerEndsBottomSheet } from './LockDownTimerEndsBottomSheet'
import { TimeSegment } from './NewEliteLandingRebalancingTimerSection'
import { GoToPortfolioButton } from './GoToPortfolioButton'
import { useNewEliteLandingAnalyticsScreen } from '../analytics/NewEliteLandingAnalyticsContext'
import {
    NewEliteLandingBottomSheetName,
    NewEliteLandingEventId,
    trackNewEliteUserClicked
} from '../analytics/newEliteLandingAnalytics'
import { useEliteBuyCtaExtras } from '../../../components/elite/EliteBuyCtaExtrasContext'

export default function LockDownCounter({
    gracePeriodEndTimestamp
}: {
    gracePeriodEndTimestamp?: number | null
}) {
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const analyticsScreen = useNewEliteLandingAnalyticsScreen()
    const eliteBuyCtaExtras = useEliteBuyCtaExtras()
    const [lockDownTargetDate] = useState(() => gracePeriodEndTimestamp ?? Date.now() + 1000 * 60 * 60 * 24 * 30)
    const time = useCountdown(lockDownTargetDate)

    const handleTimerEndsInfoClick = () => {
        trackNewEliteUserClicked(analyticsScreen, NewEliteLandingEventId.LockDownTimerEndsInfoOpen, {
            ...eliteBuyCtaExtras,
            bottomSheetName: NewEliteLandingBottomSheetName.LockDownTimerEndsInfo
        })
        openBottomSheet(<LockDownTimerEndsBottomSheet onDismiss={closeBottomSheet} />)
    }

    return (
        <div className='flex flex-col items-center px-5'>
            <GoToPortfolioButton eventId={NewEliteLandingEventId.GoToPortfolioGracePeriod} />
            <div className='flex flex-col items-center gap-4'>
                <div>
                    <img src='/images/new-elite/powerup-logo.svg' alt='powerup-logo' className='w-16 h-16 rounded-2xl' />
                </div>
                <div className="text-[#65321D] text-lg text-center font-medium max-w-[250px] leading-[1.4]">
                    Your access to PowerUp app will be restricted in
                </div>
            </div>
            <div className="flex flex-row gap-2">
                <TimeSegment fontSize="34px" color="#CC5C2D" secondaryColor="#23232399" value={time.days} label='days' />
                <TimeSegment fontSize="34px" color="#CC5C2D" secondaryColor="#23232399" value={time.hours} label='hours' />
                <TimeSegment fontSize="34px" color="#CC5C2D" secondaryColor="#23232399" value={time.minutes} label='minutes' />
                <TimeSegment fontSize="34px" color="#CC5C2D" secondaryColor="#23232399" value={time.seconds} label='seconds' />
            </div>
            <div className='flex flex-col items-center gap-3 max-w-[300px]'>
                <div className="text-[#65321D] text-sm text-center font-normal leading-[1.4]">
                    Your Elite membership has expired. Renew now for continued access to the full PowerUp experience.
                </div>
                <div
                    className='underline text-center text-sm text-[rgba(101,50,29,0.60)] cursor-pointer'
                    onClick={handleTimerEndsInfoClick}
                >
                    What happens when access period ends?
                </div>
            </div>
        </div>
    )
}